import { type FC } from "react";
import { ActionDisabledTooltip } from "../../common/components/ActionDisabledTooltip";
import { VisibleWhenPermitted } from "../../common/components/VisibleWhenPermitted";
import { useSelectedOrganization } from "../../organizations/hooks";
import { AddLensSource } from "../components/source-types-dropdown/AddLensSource";
import { useLensSourceTypes } from "../hooks";

interface AddLensSourceContainerProps {
    buttonClassName?: string;
}

const AddLensSourceButton: FC<AddLensSourceContainerProps> = ({ buttonClassName }) => {
    const { loading, types } = useLensSourceTypes();
    const { permissions } = useSelectedOrganization();

    return (
        <ActionDisabledTooltip placement="left" hasPermission={permissions?.updateLensSources ?? false}>
            <AddLensSource
                loading={loading}
                types={types}
                disabled={!permissions?.updateLensSources}
                buttonClassName={buttonClassName}
            />
        </ActionDisabledTooltip>
    );
};

export const AddLensSourceContainer: FC<AddLensSourceContainerProps> = ({ buttonClassName }) => {
    return (
        <VisibleWhenPermitted when={(permissions) => permissions?.readLensSources ?? false}>
            <AddLensSourceButton buttonClassName={buttonClassName} />
        </VisibleWhenPermitted>
    );
};
